import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginComponent } from '../../../modules/account/views/login/login.component'

import { AccountModule} from '../../../modules/account/account.module'


import { ModalOptionsMainComponent } from './modal-options-main/modal-options-main.component';
import { ModalOptionsFormComponent } from './modal-options-form/modal-options-form.component';
import { ModalOptionsOfferComponent } from './modal-options-offer/modal-options-offer.component';
import { ModalOptionsCarouselComponent } from './modal-options-carousel/modal-options-carousel.component';
import { ModalOptionsLoanSelectComponent } from './modal-options-loan-select/modal-options-loan-select.component';
import { ModalOptionsCreditLockComponent } from './modal-options-credit-lock/modal-options-credit-lock.component';
import { ModalOptionsStraightDeclineComponent } from './modal-options-straight-decline/modal-options-straight-decline.component';
import { ModalOptionsAddCoapplicantComponent } from './modal-options-add-coapplicant/modal-options-add-coapplicant.component';
import { ModalOptionsExceptonFlowComponent } from './modal-options-excepton-flow/modal-options-excepton-flow.component';
import { ModalOptionsSuccessComponent } from './modal-options-success/modal-options-success.component';
import { ModalOptionsErrorComponent } from './modal-options-error/modal-options-error.component';
import { ModalOptionsPartialApprovedComponent } from './modal-options-partial-approved/modal-options-partial-approved.component';
import { ModalOptionsPartnerDownComponent } from './modal-options-partner-down/welcome-back/modal-options-partner-down.component';
import { ModalOptionsComponent } from './modal-options.component';
import { PayInProcessPopupComponent } from './popups/pay-in-process/pay-in-process.component';
import { AutopayPopupComponent } from '../autopay-popup/autopay-popup.component';
import { WelcomeBackPopupComponent } from './popups/welcome-back/welcome-back.component';
import { MobileValidationComponent } from './popups/mobile-validation/mobile-validation.component';
import { SessionTimeoutPopupComponent } from './popups/session-timeout/session-timeout.component';
import { InvalidStatePopupComponent } from './popups/invalid-state/invalid-state.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HooverPopupComponent } from '../hoover-popup/hoover-popup.component';
//import { TransferHttpCacheModule } from '@angular/ssr';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgSelectModule } from '@ng-select/ng-select';
//import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { ModalOptionsDentistSelectComponent } from './modal-options-dentist-select/modal-options-dentist-select.component';
import { ModalOptionsDentistSelectCardsComponent } from './modal-options-dentist-select/modal-options-dentist-select-cards/modal-options-dentist-select-cards.component';
import { NgxMaskModule } from 'ngx-mask';
import { HawaiiMessagePopupComponent } from './popups/hawaii-message/hawaii-message.component';

import { WebPreQualOptionsGetPhoneNumberComponent } from '../web-prequal-options-get-phonenumber/web-prequal-options-get-phonenumber.component';
import { WebPreQualOptionsQRCodeComponent } from './web-prequal-options-qr-code/web-prequal-options-qr-code.component';
import {WebPreQualSecurityComponent} from './popups/web-prequal-security/web-prequal-security.component';

import {WebPreQualGoogleMapsWrapperComponent} from  './web-prequal-googlemaps-wrapper.component/web-prequal-googlemaps-wrapper.component'

@NgModule({ declarations: [
        ModalOptionsMainComponent,
        ModalOptionsLoanSelectComponent,
        ModalOptionsCarouselComponent,
        ModalOptionsOfferComponent,
        ModalOptionsFormComponent,
        ModalOptionsCreditLockComponent,
        ModalOptionsStraightDeclineComponent,
        ModalOptionsExceptonFlowComponent,
        ModalOptionsAddCoapplicantComponent,
        ModalOptionsErrorComponent,
        ModalOptionsSuccessComponent,
        // ModalOptionsAddCoapplicantComponent,
        ModalOptionsPartialApprovedComponent,
        ModalOptionsPartnerDownComponent,
        ModalOptionsComponent,
        PayInProcessPopupComponent,
        AutopayPopupComponent,
        WelcomeBackPopupComponent,
        MobileValidationComponent,
        SessionTimeoutPopupComponent,
        InvalidStatePopupComponent,
        HooverPopupComponent,
        ModalOptionsDentistSelectComponent,
        ModalOptionsDentistSelectCardsComponent,
        HawaiiMessagePopupComponent,
        WebPreQualOptionsGetPhoneNumberComponent,
        WebPreQualOptionsQRCodeComponent,
        WebPreQualSecurityComponent,
    ],
    exports: [ModalOptionsComponent, HooverPopupComponent, WebPreQualSecurityComponent], 
     imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        WebPreQualGoogleMapsWrapperComponent,
       // TransferHttpCacheModule,
        NgSelectModule,
       // GooglePlaceModule,
        //AccountModule,
        //LoginComponent,
        NgxMaskModule.forRoot()], providers: [provideHttpClient(withInterceptorsFromDi())],
         schemas:[NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA] 
    })
export class ModalOptionsModule {}
